import { defaultsDeep } from 'lodash-es';
import Vue from "vue";
// 可以接受对象和数组,
// [key],{key1:key2}
// key1和key 会挂载到this实例中
// key2和key 会通过 getter/setter 获取或处理对应数据
const mapBaseFn = (args, getter, setter) => {
  const allMap = [];
  const map = {};
  for (const params of args) {
    let kvMap;
    if (typeof params === 'string') {
      kvMap = [[params, params]];
    } else if (Array.isArray(params)) {
      kvMap = params.map((key) => [key, key]);
    } else if (typeof params === 'object') {
      kvMap = Object.keys(params).map((key) => [key, params[key]]);
    }
    allMap.push(...kvMap);
  }
  for (const [k, v] of allMap) {
    map[k] = {
      get() {
        return getter.call(this, v);
      },
      set(value) {
        return setter.call(this, value, v);
      }
    };
  }
  return map;
};

// ...mapVFOptions(["xxx"])  将配置的option的xxx字段绑定到this上
// 只支持侧边配置区域使用
// 支持修改并实时更新到options this.xxx = '....'
export const mapVFOptions = (...keys) => {
  return mapBaseFn(keys,
    function (key) { return this.optionModel[key]; },
    function (value, key) { return Vue.set(this.optionModel, key, value); }
  );
};
// ...mapVFAssignField() 只支持主组件使用,用于修改关联其他字段
// 可以直接赋值
export const mapVFAssignField = (...keys) => {
  return mapBaseFn(keys,
    function (key) {
      const formKey = this.options[key];
      return this.curFieLdForm[formKey];
    },
    function (value, key) {
      const formKey = this.options[key];
      setWidgetValue.call(this, formKey, value);
    });
};
export const computedField = (formKey) => {
  return {
    get() {
      return this.curFieLdForm[formKey];
    },
    set(value) {
      setWidgetValue.call(this, formKey, value);
    }
  };
};
// 修改表单内其他组件的数据
export function setWidgetValue(key, value) {
  let formKey = key;
  if (this.isInit) return; // 如果处于初始化状态,不修改值
  if (key) {
    Vue.set(this.curFieLdForm, key, value);
    // 子表的ref会有行的id
    if (this.subFormRowId) formKey = `${formKey}@row${this.subFormRowId}`;
    const widget = this.getWidgetRef(formKey, false);
    if (widget) widget.setValue(value);
  }
}

/**
 *
 * @param {Object} object 新的schema,仅合并同位置的数据
 * @param {Object} sources 来源schema
 * @param {Function|undefined} customizer 后续处理函数,对新schema进行细致处理,可不传
 * @returns {Object} 全新的schema
 */
export function extendsSchema(object, sources, customizer) {
  const schema = defaultsDeep(object, sources);
  customizer && customizer.call(schema, schema);
  return schema;
}

// 创建列表单
export class Grid {
  column = 1;
  data = [];
  itemNum = 0;
  constructor(column = 1, data) {
    if (column === 1) {
      this.data = data;
    } else {
      this.column = column;
      this.addCols(data);
    }
  }
  addCols(list) {
    let { itemNum } = this;
    const { column } = this;
    if (column === 1) {
      this.data.push(...list);
      itemNum += list.length;
    } else {
      const span = Math.floor(24 / column);
      for (const item of list) {
        const rowIndex = Math.floor(itemNum / column);
        let row;
        if (itemNum % column) {
          row = this.data[rowIndex];
        } else {
          const id = "grid" + generateId();
          row = {
            id: id,
            type: "grid",
            alias: "",
            category: "container",
            icon: "grid",
            cols: [],
            options: {
              name: id,
              hidden: false,
              gutter: 12,
              colHeight: null,
              customClass: []
            }
          };
          this.data.push(row);
        }
        const col = {
          id: 'grid-col-' + generateId(),
          type: "grid-col",
          category: "container",
          icon: "grid-col",
          internal: true,
          widgetList: [item],
          options: {
            name: "gridCol" + generateId(),
            hidden: false,
            span,
            offset: 0,
            push: 0,
            pull: 0,
            responsive: false,
            md: 12,
            sm: 12,
            xs: 12,
            customClass: ""
          }
        };
        row.cols.push(col);
        itemNum++;
      }
    }
    this.itemNum = itemNum;
  }
}
export function generateId() {
  return Math.floor(Math.random() * 100000 + Math.random() * 20000 + Math.random() * 5000);
}

